import { Button, CircularProgress, Input, Stack } from "@mui/material";
import React, { useEffect, useState, useCallback, useRef } from "react";
import '../CreateArticle/CreateArticle.css'
import { useNavigate } from "react-router";
import "./EditArticle.css";
import moment from "moment";
import big from "../images/big.png";
import ReactQuill from "react-quill";
import "../../node_modules/react-quill/dist/quill.snow.css";
import axiosApiInstance from "../axios";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ReactTags from "react-tag-autocomplete";
import CAlertBox from '../CAlertBox/CAlertBox';

const EditArticle = ({ onEditChange, currentArticle, id, tag,catg }) => {
  const [header, setHeader] = useState(currentArticle.title);
  const [body, setBody] = useState(currentArticle.description);
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [tagName, setTagName] = useState([]);
  const [files, setFiles] = useState([]);
  const [showName, setShowName] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setcategory] = useState([])
  const [categoryName, setCategoryName] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  // useEffect(() => {
  //   currentArticle?.attachments && currentArticle?.attachments?.length > 0 ? 
  //   currentArticle?.attachments && currentArticle?.attachments?.map((attach)=>{
  //     const allAttach = Array.from(attach).map((file) => file);
  //     setShowName((prevNames) => prevNames.concat(attach.fileName));
  //     setFiles((prevAtt) => prevAtt.concat(attach));
  // })
  //   : 
  //   setShowName([])
    
  // }, []);

 
// console.log("showNames",showName)

  const [tags, setTags] = useState([]);

  useEffect(() => {
    let tagItem = [];
    tag?.map((t) => {
      tagItem.push({ name: t });
    });
    setTags(tagItem);
  }, []);

  useEffect(() => {
    let CatItem = [];
    catg?.map((t) => {
      CatItem.push({ name: t });
    });
    setcategory(CatItem);
  }, []);

  const editTitle = (e) => {
    e.preventDefault();
    setHeader(e.target.value);
  };
  const editDesc = (e) => {
    // e.preventDefault();
    setBody(e);
  };

 

  const onFileChange = (e) => {
    const allAttach = Array.from(e.target.files).map((file) => file);
    const fileArray = Array.from(e.target.files).map((file) => file.name);
    const fileSize = Array.from(e.target.files).map((file) => file.size);

    const fileExtension = fileArray.toString().split(".").at(-1);
    const allowedFileTypes = [
      "jpg",
      "png",
      "zip",
      "txt",
      "doc",
      "docx",
      "jpg",
      "png",
      "jpeg",
      "xlsx",
      "xls",
      "pdf",
    ];
    if (!allowedFileTypes?.includes(fileExtension)) {
      // window.alert(
      //   `File does not support. Files type must be ${allowedFileTypes.join(
      //     ", "
      //   )}`
      // );
      setAlertMessage(`File does not support. Files type must be ${allowedFileTypes.join(", ")}`);
      return false;
    }
    if (fileSize > 5163523) {
      // window.alert("Please upload a file smaller than 5 MB");
      setAlertMessage("Please upload a file smaller than 5 MB");
      return false;
    }
    setFiles((prevAtt) => prevAtt.concat(allAttach));
    setShowName((prevNames) => prevNames.concat(fileArray));
    
  };
  useEffect(() => {
    for (let j = 0; j < files.length; j++) {
      console.log( files[j]);
  }}, [files])
  

  const remFile = (e) => {
    let x = e.target.getAttribute("delattach");
    setFiles(files.filter((v) => v.name !== x));
    setShowName(showName.filter((art) => art !== x));
  };

  useEffect(() => {
    let tagItem = [];

    let resData;

    axiosApiInstance
      .get("/tags")

      .then((req) => {
        resData = req.data.data;
        for (let i = 0; i < resData.length; i++) {
          let idItem = i;
          let data = resData[i];
          tagItem.push({ id: idItem, name: data });
        }

        setSuggestions(tagItem);
      });
  }, []);

  useEffect(() => {
    let Item = [];

    let resData;

    axiosApiInstance
      .get("/category")

      .then((req) => {
        resData = req.data.data;
        for (let i = 0; i < resData.length; i++) {
          let idItem = resData[i].id;
          let data = resData[i].name;
          Item.push({ id: idItem, name: data });
        }

        setCategories(Item);
      });
  }, []);

  const reactTags = useRef();

  const onDelete = useCallback(
    (tagIndex) => {
      setTags(tags.filter((_, i) => i !== tagIndex));
    },
    [tags]
  );

  const onAddition = useCallback(
    (newTag) => {
      var names = tags.map(({ name }) => name);
      if (tags.length + 1 > 10) {
        // window.alert("Maximum 10 tags are allowed");
        setAlertMessage("Maximum 10 tags are allowed");
        return false;
      }
      if (!names.includes(newTag.name)) {
        setTags([...tags, newTag]);
      }
    },
    [tags]
  );

  useEffect(() => {
    setTagName(Array.isArray(tags) ? tags.map((x) => x.name) : []);
  }, [tags]);

  const onCategoryDelete = useCallback(
    (categoryIndex) => {
      setcategory(category.filter((_, i) => i !== categoryIndex));
    },
    [category]
  );

  const onCategoryAddition = useCallback(
    (newcategory) => {
      var names = category.map(({ name }) => name);

      if (!names.includes(newcategory.name)) {
        setcategory([...category, newcategory]);
      }
    },
    [category]
  );



  useEffect(() => {
    setCategoryName(Array.isArray(category) ? category.map((x) => x.name) : []);
  }, [category]);



  const fetchedToken = localStorage.getItem("token");

  const EditedForm = (e) => {
    setLoading(true);
    e.preventDefault();
    let bodyFormData = new FormData();
    bodyFormData.append("Id", id);
    bodyFormData.append("Title", header);
    bodyFormData.append("Description", body);
    for (let i = 0; i < tags.length; i++) {
      let TagList = tagName[i];
      bodyFormData.append("Tags", TagList);
    }
    for (let i = 0; i < category.length; i++) {
      let categoryList = categoryName[i];
      bodyFormData.append("Category", categoryList);
    }
    for (let j = 0; j < files.length; j++) {
      let finalFiles = files[j];
      bodyFormData.append("file", finalFiles);
    }
    axiosApiInstance
      .patch("/article", bodyFormData)
      .then((res) => {
        if (res.data.succeeded === true) {
          onEditChange();
          setLoading(false);
        }
        if (res.data.succeeded === false) {
          setLoading(false);
          // alert("There was an error.Pls Try Again");
          setAlertMessage("There was an error.Pls Try Again");
          // window.location.reload();
        }
      })
      .catch((err) => setAlertMessage(err));
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
    clipboard: { matchVisual: false },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <div className="create-art">
      <Button
        className="back-btn"
        onClick={onEditChange}
        style={{
          backgroundColor: "#0A387D",
        }}
        variant="contained"
      >
        Back
      </Button>

      <p className="art-date-edit">
        {moment(currentArticle.createdDate).format("MMMM Do YYYY")}
      </p>
      <div className="edit-art-title">
        <p>Header</p>
        <textarea type="text" value={header} onChange={editTitle}></textarea>
      </div>
      <div className="edit-art-desc">
        <p>Body</p>
        <ReactQuill type="text" value={body} onChange={editDesc} />
      </div>

      <br />
      <p className="tag-field">Tags</p>
      <ReactTags
        ref={reactTags}
        tags={tags}
        suggestions={suggestions}
        onDelete={onDelete}
        allowNew
        onAddition={onAddition}
        placeholderText={"Enter Tags"}
        limitTags={2}
        // noSuggestionsText ={"none"}
      />

<br />
      <p className="tag-field">Category</p>
      <ReactTags
        ref={reactTags}
        tags={category}
        suggestions={categories}
        onAddition={onCategoryAddition}
        onDelete={onCategoryDelete}
        placeholderText={"Select"}
        noSuggestionsText={"No Options Available"}
      />

      <div className="attachment">
        <Stack direction="row" alignItems="center" spacing={2}>
          <label htmlFor="contained-button-file">
            <Input
              id="contained-button-file"
              style={{ display: "none" }}
              onChange={onFileChange}
              multiple
              type="file"
            />
            <Button
              className="addattach"
              // disabled={isDisable}
              variant="contained"
              component="span"
            >
              Drag Files Here
            </Button>
          </label>
        </Stack>
      </div>
      {/* {showName?.length > 0 ? (
        <div className="showFile">
          {showName}
          <DeleteOutlineIcon
            className="deleteFile"
            delattach={showName}
            onClick={remFile}
          />
        </div>
      ) : (
        " "
      )} */}

{showName?.length > 0
              ? showName && showName?.map((shw, id) => (
                <div className="showFile" key={id}>
                  {shw}
                  <DeleteOutlineIcon
                    className="delFile"
                    delattach={shw}
                    onClick={remFile}
                  />
                </div>
              ))
              : " "}

      <div className="create-art-controls">
        <Button
          className="save-back-btn"
          style={{
            backgroundColor: "#0A387D",
          }}
          variant="contained"
          onClick={EditedForm}
        >
          {loading ? <CircularProgress style={{ color: "white" }} /> : "Save"}
        </Button>
        <Button
          className="cancel-btn-art"
          onClick={onEditChange}
          style={{
            backgroundColor: "#707070",
          }}
          variant="contained"
        >
          Cancel
        </Button>
      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </div>
  );
};

export default EditArticle;
